import React, { useRef } from "react";
import { Modal } from "components/Modal";
import EditEmailAddressForm, {
  EditEmailAddressFormProps,
  EmailAddressFormProps,
} from "components/EditEmailAddressForm";

export interface EditEmailAddressFormModalProps
  extends EditEmailAddressFormProps {
  title: React.ReactNode;
  loading?: boolean;
  submissionLoading?: boolean;
  submit: (values: EmailAddressFormProps) => Promise<void>;
  cancel: () => void;
}

export const EditEmailAddressFormModal: React.FC<
  EditEmailAddressFormModalProps
> = ({
  loading = false,
  submissionLoading = false,
  submit,
  cancel,
  title,
  ...formProps
}: EditEmailAddressFormModalProps) => {
  const formRef = useRef(null);

  return (
    <Modal
      title={title}
      okText="Submit"
      loading={loading}
      submissionLoading={submissionLoading}
      onCancel={cancel}
      onOk={async () => submit(await formRef.current.getEmailAddress())}
      width={700}
    >
      <EditEmailAddressForm {...formProps} ref={formRef} />
    </Modal>
  );
};

export default EditEmailAddressFormModal;
